import { Component } from 'react';
import { connect } from 'react-redux';

import CompanyChooser from './registration/CompanyChooser';
import { getCountryLabel } from '../helpers/components';
import {
  availableRegisterCountriesSelector,
  messagesSelector
} from '../helpers/selectors';
import { navigateToCreationPage } from '../utils/utils';

/**
 * Shown to a Keycloak-authenticated user who has no member yet (GET /v2/members/me
 * returned 404) and whose company could not be resolved automatically, on brands
 * that publish their countries in the config (keycloak.useCompanyFlags). The user
 * picks a country flag - or enters an invitation code when the brand allows it -
 * and continues into the registration flow (CompanyChooser owns those states).
 */
class SsoRegisterCompany extends Component {
  constructor(props) {
    super(props);
    this.renderFlagList = this.renderFlagList.bind(this);
  }

  renderFlagList(countries) {
    const { m } = this.props;

    return (
      <div className="text-center mb-35">
        <ul className="flag-country-selector">
          {countries.map((country) => (
            <li
              key={country.iso}
              onClick={() => navigateToCreationPage(country.companyId)}
            >
              <i style={{ backgroundImage: `url(${country.iconUrl})` }} />
              <span>{getCountryLabel(m, country)}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  render() {
    return (
      <div className="sso-register-company">
        <div className="src-inner">
          <CompanyChooser
            items={this.props.registerCountries}
            titleClassName="src-title text-center f-25 mt-40 mb-10"
            renderList={this.renderFlagList}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    registerCountries: availableRegisterCountriesSelector(state),
    m: messagesSelector(state)
  };
}

export default connect(mapStateToProps)(SsoRegisterCompany);
